import { render, staticRenderFns } from "./OrderCheck.vue?vue&type=template&id=51917dca&scoped=true&lang=pug&"
import script from "./OrderCheck.vue?vue&type=script&lang=js&"
export * from "./OrderCheck.vue?vue&type=script&lang=js&"
import style0 from "./OrderCheck.vue?vue&type=style&index=0&id=51917dca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51917dca",
  null
  
)

export default component.exports